let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <updateTime>更新时间, string (19), YYYY-MM-DD HH:MM:SS,为空时WMS自动生成</updateTime>
    <createTime>创建时间, string (19), YYYY-MM-DD HH:MM:SS,为空时WMS自动生成</createTime>
    <actionType>add|update, 必填</actionType>
    <item>
        <packCode>包装代码, string (50), 必填</packCode>
        <description>包装描述,string (50), 必填</description>
        <eachScalingQty>主单位数量, double</eachScalingQty>
        <eachDescribe>主单位描述, string (50)</eachDescribe>
        <isUsingInnerPack>是否使用内包装, boolean, 默认为N</isUsingInnerPack>
        <innerPackIsDisplay>是否显示内包装, boolean, 默认为N</innerPackIsDisplay>
        <innerPackScalingQty>内包装数量, double</innerPackScalingQty>
        <innerPackDescribe>内包装描述, string (50)</innerPackDescribe>
        <isUsingCase>是否使用箱, boolean, 默认为N</isUsingCase>
        <caseIsDisplay>是否显示箱, boolean, 默认为N</caseIsDisplay>
        <caseScalingQty>箱数量, double</caseScalingQty>
        <caseDescribe>箱描述, string (50)</caseDescribe>
        <isUsingPallet>是否使用托盘, boolean, 默认为N</isUsingPallet>
        <palletIsDisplay>是否显示托盘, boolean, 默认为N</palletIsDisplay>
        <palletScalingQty>托盘数量, double</palletScalingQty>
        <palletDescribe>托盘描述, string (50)</palletDescribe>
    </item>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

export default {
    xmlRequest,
    xmlResponse
}



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.packuom.singleitem.synchronize.js